import React, { useEffect } from 'react'
import styles from './styles.css'
import withReactTimeout, { ReactTimeoutProps } from 'react-timeout'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import { InterstitialProps } from '#src/components/Path/Interstitials'
import { usePathContext } from '../../PathContext'

const Generic: React.SFC<InterstitialProps & ReactTimeoutProps> = ({
  setTimeout: setReactTimeout,
  title,
  body
}) => {
  const pathContext = usePathContext()

  useEffect(() => {
    setReactTimeout && setReactTimeout(pathContext.onPageSubmitted, 4000)
  }, [])

  return (
    <section className={styles.page}>
      {title && <div className={styles.header}>{title}</div>}
      {body && <div className={styles.body}>{body}</div>}

      <div className={styles.row}>
        <FullBlockLoader loader={CircleLoader} />
      </div>
    </section>
  )
}

export default withReactTimeout(Generic)
